import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RoleService {

    constructor() { }

    isLeaseholder(user: any) {
        return this.hasRole(user, 'leaseholder');
    }

    isSharedOwner(user: any) {
        return this.hasRole(user, 'sharedowner');
    }

    isNuvu(user: any) {
        return this.hasRole(user, 'nuvu');
    }

    isPrs(user: any) {
        return this.hasRole(user, 'prs');
    }

    hasRole(user: any, role: string) {
        if (user && user.profile && user.profile.role) {
            for (let i = 0; i < user.profile.role.length; i++) {
                if (user.profile.role[ i ] == role) {
                    return true;
                }
            }
        }
        return false;
    }
}
